export default [{
  path: '/empresas',
  component: {
    name: 'empresasBase',
    template: '<router-view />',
    meta: {
      resource: 'empresa',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'empresas',
    component: () => import('@/app-modulo/comuns/empresa/EmpresaView.vue'),
    meta: {
      resource: 'empresa',
      action: 'read',
      navActiveLink: 'empresas',
      pageTitle: 'Cadastro de empresas',
      breadcrumb: [
        {
          text: 'Empresas',
          to: { name: 'empresas' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-emp',
    component: () => import('@/app-modulo/comuns/empresa/shared/components/cadastro/Empresa.vue'),
    meta: {
      resource: 'empresa',
      action: 'create',
      navActiveLink: 'empresas',
      pageTitle: 'Cadastro de empresas',
      breadcrumb: [
        {
          text: 'Empresas',
          to: { name: 'empresas' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-emp' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-emp',
    component: () => import('@/app-modulo/comuns/empresa/shared/components/cadastro/Empresa.vue'),
    meta: {
      resource: 'empresa',
      action: 'update',
      navActiveLink: 'empresas',
      pageTitle: 'Cadastro de empresas',
      breadcrumb: [
        {
          text: 'Empresas',
          to: { name: 'empresas' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-emp' },
          active: true,
        },
      ],
    },
  }],
}]
